import {Component, Input,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';

export interface CheckmarkListEntry {
  name?: string;
  value: string;
}

@Component({
  selector: 'dcp-checkmark-list',
  templateUrl: './checkmark-list.component.html',
  styleUrls: ['./checkmark-list.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CheckmarkListComponent {
  @Input() entries: CheckmarkListEntry[] = [];
  @Input() useBoxIcon: boolean = false;
}
